import { baseApiURL } from "../../Utilities/utility";

export function GetAllQuotationList(
    siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId,
    data
) {
    const options = {
        method: "post",
        headers: {
            Accept: "application/json, text/plain, */*",
            "Content-Type": "application/json",
            Authorization: "Bearer " + siteToken.token,
            AzureToken: azureToken,
            UserEmail: userEmail,
            RoleName: roleName,
            Gid: gid,
            Roleid: roleId,
            userId : userId
        },
        body: JSON.stringify(data),
    };
    return fetch(
        baseApiURL + "/Quotation/GetAllQuotationList",
        options
    )
        .then((response) => response.json())
        .then((resp) => {
            return resp.result;
        })
        .catch((error) => {
            console.log("Error : ", error);
        });
}


export function getQuotationRefNo(
    siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId,
    

) {
    const options = {
        method: "get",
        headers: {
            Authorization: "Bearer " + siteToken.token,
            AzureToken: azureToken,
            UserEmail: userEmail,
            RoleName: roleName,
            Gid: gid,
            Roleid: roleId,
            userId : userId
        },

    };
    return fetch(baseApiURL + "/Quotation/GetQuotationRefNo" , options)
        .then((response) => response.json())
        .then((data) => {
            return data.result;
        })
        .catch((error) => {
            console.log("Error : ", error);
        });
}

export function GetOfficeList(
    siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId,
    selectValue


) {
    const options = {
        method: "get",
        headers: {
            Authorization: "Bearer " + siteToken.token,
            AzureToken: azureToken,
            UserEmail: userEmail,
            RoleName: roleName,
            Gid: gid,
            Roleid: roleId,
            userId : userId,
            
        },

    };
    return fetch(baseApiURL + "/Quotation/GetOfficeList?selectValue=" + selectValue, options)
        .then((response) => response.json())
        .then((data) => {
            return data.result;
        })
        .catch((error) => {
            console.log("Error : ", error);
        });
}


export function GetCompetitorList(
    siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId,
    selectValue

) {
    const options = {
        method: "get",
        headers: {
            Authorization: "Bearer " + siteToken.token,
            AzureToken: azureToken,
            UserEmail: userEmail,
            RoleName: roleName,
            Gid: gid,
            Roleid: roleId,
            userId : userId
        },

    };
    return fetch(baseApiURL + "/Quotation/GetCompetitorList?selectValue=" + selectValue, options)
        .then((response) => response.json())
        .then((data) => {
            return data.result;
        })
        .catch((error) => {
            console.log("Error : ", error);
        });
}


export function GetDetailsOfMLFB(
    siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId,
    data
) {
    const options = {
        method: "post",
        headers: {
            Accept: "application/json, text/plain, */*",
            "Content-Type": "application/json",
            Authorization: "Bearer " + siteToken.token,
            AzureToken: azureToken,
            UserEmail: userEmail,
            RoleName: roleName,
            Gid: gid,
            Roleid: roleId,
            userId : userId
        },
        body: JSON.stringify(data),
    };
    return fetch(
        baseApiURL + "/Quotation/GetDetailsOfMLFB",
        options
    )
        .then((response) => response.json())
        .then((resp) => {
            return resp.result;
        })
        .catch((error) => {
            console.log("Error : ", error);
        });
}



export function GetAllNonStdFeatures(siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId,
    zcodeIDs,
    DBSeriesID,
    DBTypeID
    ) {
    const options = {
        method: "get",
        headers: {
            Authorization: "Bearer " + siteToken.token,
            AzureToken: azureToken,
            UserEmail: userEmail,
            RoleName: roleName,
            Gid: gid,
            Roleid: roleId,
            userId : userId
        },

    };
    return fetch(baseApiURL + "/Quotation/getAllNonStandardFeatures?zcodeIDs="+ zcodeIDs +'&DBSeriesID='+ DBSeriesID + '&DBTypeID=' + DBTypeID, options)
        .then((response) => response.json())
        .then((data) => {
            return data.result;
        })
        .catch((error) => {
            console.log("Error : ", error);
        });
}



export function CreateUpdateQuotation(
    siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId,
    data,
    QuotationType
) {
    const options = {
        method: "post",
        headers: {
            Accept: "application/json, text/plain, */*",
            "Content-Type": "application/json",
            Authorization: "Bearer " + siteToken.token,
            AzureToken: azureToken,
            UserEmail: userEmail,
            RoleName: roleName,
            Gid: gid,
            Roleid: roleId,
            userId : userId
        },
        body: JSON.stringify(data),
    };
    return fetch(
        baseApiURL + "/Quotation/"+QuotationType,
        options
    )
        .then((response) => response.json())
        .then((resp) => {
            return resp.result;
        })
        .catch((error) => {
            console.log("Error : ", error);
        });
}


export function GetQuotations(siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId,
    quotationId,
    quotationDetailId
    
    ) {
    const options = {
        method: "get",
        headers: {
            Authorization: "Bearer " + siteToken.token,
            AzureToken: azureToken,
            UserEmail: userEmail,
            RoleName: roleName,
            Gid: gid,
            Roleid: roleId,
            userId : userId
        },

    };
    return fetch(baseApiURL + "/Quotation/getQuotations?quotationId="+ quotationId +'&quotationDetailId='+ quotationDetailId, options)
        .then((response) => response.json())
        .then((data) => {
            return data.result;
        })
        .catch((error) => {
            console.log("Error : ", error);
        });
}


export function GetSelectedZcodes(siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId,
    zcodeIDs,
    bool
    
    ) {
    const options = {
        method: "get",
        headers: {
            Authorization: "Bearer " + siteToken.token,
            AzureToken: azureToken,
            UserEmail: userEmail,
            RoleName: roleName,
            Gid: gid,
            Roleid: roleId,
            userId : userId
        },

    };

        const zcode =zcodeIDs.toString();
        return fetch(baseApiURL + "/Quotation/GetSelectedZCode?zcodeIDs="+ zcode +'&zCodestring='+ bool, options)
        .then((response) => response.json())
        .then((data) => {
            return data.result;
        })
        .catch((error) => {
            console.log("Error : ", error);
        });
  
    }

    export function DeleteQuotation(siteToken,
        azureToken,
        userId,
        userEmail,
        gid,
        roleName,
        roleId,
        id,
        quoteId
        
        ) {
        const options = {
            method: "post",
            headers: {
                Authorization: "Bearer " + siteToken.token,
                AzureToken: azureToken,
                UserEmail: userEmail,
                RoleName: roleName,
                Gid: gid,
                Roleid: roleId,
                userId : userId
            },
    
        };

            return fetch(baseApiURL + "/Quotation/DeleteQuotation?id="+ id +'&QuotationID='+ quoteId, options)
            .then((response) => response.json())
            .then((data) => {
                return data.result;
            })
            .catch((error) => {
                console.log("Error : ", error);
            });
      
        }


        export function AddBulk(
            siteToken,
            azureToken,
            userId,
            userEmail,
            gid,
            roleName,
            roleId,
            data,
            bulk
        ) {
            const options = {
                method: "post",
                headers: {
                    Accept: "application/json, text/plain, */*",
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + siteToken.token,
                    AzureToken: azureToken,
                    UserEmail: userEmail,
                    RoleName: roleName,
                    Gid: gid,
                    Roleid: roleId,
                    userId : userId
                },
                body: JSON.stringify(data),
            };
            return fetch(
                baseApiURL + "/Quotation/AddBulkDB?txtBulkDB=" + bulk,
                options
            )
                .then((response) => response.json())
                .then((resp) => {
                    return resp.result;
                })
                .catch((error) => {
                    console.log("Error : ", error);
                });
        }



        export function updateDrwingRequest(siteToken,
            azureToken,
            userId,
            userEmail,
            gid,
            roleName,
            roleId,
            quotId,
          
            
            ) {
            const options = {
                method: "get",
                headers: {
                    Authorization: "Bearer " + siteToken.token,
                    AzureToken: azureToken,
                    UserEmail: userEmail,
                    RoleName: roleName,
                    Gid: gid,
                    Roleid: roleId,
                    userId : userId
                },
        
            };
        
                return fetch(baseApiURL + "/Quotation/UpdateDrawingRequestWithMail?sList="+ quotId , options)
                .then((response) => response.json())
                .then((data) => {
                    return data.result;
                })
                .catch((error) => {
                    console.log("Error : ", error);
                });
          
            }